import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/app/(app)/resources/feeder-care-log/page.js");
